// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import router from './router'
import Index from './common.vue'
import store from '@/store'

/*vue-resource ajax插件*/
import ajax from 'vue-resource'
Vue.use(ajax)


//iview
import iView from 'iview';
import 'iview/dist/styles/iview.css';
import "../../assets/index.less";
Vue.use(iView, {
    transfer: true,
    size: 'large'
});
/*图片压缩*/
import lrz from 'lrz'

/*公共方法*/
import common from '@/common'
Vue.use(common)

import axios from '../../common/axios'
Vue.use(axios)

import mixin from '@/mixin/store'
//fetch 回溯用
import _fetch from '@/common/fetch'
Vue.use(_fetch)
Vue.config.productionTip = true;
Vue.http.options.emulateJSON = true;  //json

new Vue({
    el: '#index',
    router,
    store,
    mixins:[mixin],
    template: '<Index/>',
    components: { Index }
})


// WEBPACK FOOTER //
// ./src/pages/common/common.js